/* eslint-disable react/prop-types */
import React from 'react';
import { Button } from './style.js';

import { FaTrashAlt, FaPencilAlt, FaCheckCircle, FaPrint, FaFileAlt } from 'react-icons/fa';
import { MdStoreMallDirectory } from 'react-icons/md';

import { CgAdd } from 'react-icons/cg';

const ButtonAction = ({ Width, Action, text, ...rest }) => {
  return (
    <>
      <Button Width={Width} {...rest}>
        {Action == 'Edit' ? (
          <FaPencilAlt />
        ) : Action == 'Remove' ? (
          <FaTrashAlt style={{ fontSize: '20px' }} />
        ) : Action == 'Add' ? (
          <CgAdd />
        ) : Action == 'Status' ? (
          <FaCheckCircle />
        ) : Action == 'Print' ? (
          <FaPrint />
        ) : Action == 'Customer' ? (
          <MdStoreMallDirectory />
        ) : Action == 'Open' ? (
          <FaFileAlt />
        ) : (
          ''
        )}
        {text}
      </Button>
    </>
  );
};

export default ButtonAction;
